document.addEventListener('DOMContentLoaded', () => {
  const revealEls = document.querySelectorAll('.nm-reveal, .nm-reveal-stagger');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('nm-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
    revealEls.forEach(el => io.observe(el));
  } else {
    revealEls.forEach(el => el.classList.add('nm-visible'));
  }
  document.querySelectorAll('.nm-faq-item').forEach(item => {
    const question = item.querySelector('.nm-faq-question');
    const answer = item.querySelector('.nm-faq-answer');
    if (!question || !answer) return;
    question.addEventListener('click', () => {
      const isOpen = item.classList.contains('nm-open');
      item.closest('.nm-faq-list')?.querySelectorAll('.nm-faq-item.nm-open').forEach(openItem => {
        if (openItem !== item) {
          openItem.classList.remove('nm-open');
          openItem.querySelector('.nm-faq-answer').style.maxHeight = null;
        }
      });
      if (isOpen) {
        item.classList.remove('nm-open');
        answer.style.maxHeight = null;
      } else {
        item.classList.add('nm-open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });
  document.querySelectorAll('[data-nm-pack-grid]').forEach(grid => {
    const cards = grid.querySelectorAll('[data-nm-pack-option]');
    const picker = document.querySelector('variant-picker');
    cards.forEach(card => {
      card.addEventListener('click', () => {
        const value = card.getAttribute('data-match-value');
        if (picker) {
          const input = picker.querySelector('input[type="radio"][value="' + CSS.escape(value) + '"]');
          if (input && !input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        cards.forEach(c => c.classList.remove('nm-pack-card--active'));
        card.classList.add('nm-pack-card--active');
      });
    });
  });
});
